import Vue from 'vue';
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';


import _ from 'lodash';

export function isIsraeliIdValid(value) {
  if (value.length > 9 || value.length < 8) {
    return false;
  }
  const normalizedId = value.length < 9 ? (`00000000${value}`).slice(-9) : value;

  const counter = _.reduce(normalizedId, (counter, digit, i) => {
    const rawVal = Number(digit) * ((i % 2) + 1);
    const actualVal = rawVal > 9 ? (rawVal - 9) : rawVal;
    return counter + actualVal;
  }, 0);
  return (counter % 10 === 0);
}

function minLength(value, { min }) {
  return min <= value.length;
}

function isNotHebrew(value) {
  return !value.match(/[\u0590-\u05ff]+/);
}

function isNotSpecial(value) {
  return !value.match(/[^A-Za-z0-9]+/);
}

function exactLength(value, { length }) {
  return value.length === parseInt(length, 10);
}

function onlyDigits(value) {
  return /^\d+$/.test(value);
}

function init() {
  Vue.component('ValidationProvider', ValidationProvider);
  Vue.component('ValidationObserver', ValidationObserver);
  extend('id', {
    message: 'מספר ת.ז לא תקין',
    validate: isIsraeliIdValid,
  });
  extend('not-he', {
    message: 'אין להכניס תווים בעברית',
    validate: isNotHebrew,
  });
  extend('not-special', {
    message: 'צריכים להיות כאן ספרות או אותיות',
    validate: isNotSpecial,
  });
  extend('min-length', {
    message: 'צריכים להיות כאן לפחות {min} תווים',
    params: ['min'],
    validate: minLength,
  });
  extend('exact-length', {
    message: 'צריכים להיות כאן {length} תווים',
    params: ['length'],
    validate: exactLength,
  });
  extend('only-digits', {
    message: 'צריך להיות כאן רק מספר',
    validate: onlyDigits,
  });
}

export default {
  init,
  isIsraeliIdValid,
};




// WEBPACK FOOTER //
// ./src/rules/validators.js